exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div#recaptcha_image,div#recaptcha_widget{width:100%!important}div#recaptcha_image{height:auto!important}div#recaptcha_image>img{width:100%!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/client/styles/recaptchaResponsive.css
 ** module id = 4
 ** module chunks = 0
 **/